var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayLightBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 41,
    viewBox: "0 0 193 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.25 0H7.125A7.125 7.125 0 0 0 0 7.125v42.75A7.125 7.125 0 0 0 7.125 57H185.25a7.125 7.125 0 0 0 7.125-7.125V7.125A7.125 7.125 0 0 0 185.25 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25 1.14a5.985 5.985 0 0 1 5.985 5.985v42.75a5.987 5.987 0 0 1-5.985 5.985H7.125a5.985 5.985 0 0 1-5.985-5.985V7.125A5.985 5.985 0 0 1 7.125 1.14H185.25Zm0-1.14H7.125A7.125 7.125 0 0 0 0 7.125v42.75A7.125 7.125 0 0 0 7.125 57H185.25a7.124 7.124 0 0 0 7.125-7.125V7.125A7.126 7.126 0 0 0 185.25 0Z",
    fill: "#364663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.573 14.592a3.875 3.875 0 0 1-1.068 2.85 4.134 4.134 0 0 1-3.135 1.254 4.276 4.276 0 0 1-3.15-1.283 4.546 4.546 0 0 1 0-6.355 4.504 4.504 0 0 1 4.902-.926 3.62 3.62 0 0 1 1.34.954l-.755.756a2.85 2.85 0 0 0-2.337-1.026 3.42 3.42 0 1 0 2.394 5.885 2.737 2.737 0 0 0 .712-1.739H63.37v-1.025h4.146c.033.217.052.436.057.655ZM74.1 11.03h-3.847v2.707h3.505v1.026h-3.505v2.708H74.1v1.054h-4.959v-8.55H74.1v1.055ZM78.774 18.525h-1.097V11.03h-2.394V9.975h5.942v1.055h-2.451v7.495ZM85.414 18.525v-8.55h1.098v8.55h-1.098ZM91.385 18.525h-1.097V11.03h-2.394V9.975h5.871v1.055h-2.38v7.495ZM104.894 17.413a4.423 4.423 0 0 1-3.135 1.3 4.433 4.433 0 0 1-3.135-1.3 4.617 4.617 0 0 1 0-6.327 4.177 4.177 0 0 1 3.135-1.296 4.275 4.275 0 0 1 3.135 1.296 4.365 4.365 0 0 1 1.254 3.164 4.281 4.281 0 0 1-1.254 3.163Zm-5.458-.712a3.269 3.269 0 0 0 2.323.971 3.266 3.266 0 0 0 2.323-.971 3.619 3.619 0 0 0 0-4.902 3.265 3.265 0 0 0-4.645 0 3.62 3.62 0 0 0 0 4.902ZM107.702 18.525v-8.55h1.325l4.161 6.655V9.975h1.097v8.55h-1.14l-4.346-6.968v6.968h-1.097Z",
    fill: "#364663",
    stroke: "#364663",
    strokeWidth: 0.411,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1 30.994a6.072 6.072 0 0 0-4.269 10.373 6.07 6.07 0 0 0 10.353-4.317 5.964 5.964 0 0 0-1.758-4.319 5.97 5.97 0 0 0-4.327-1.737Zm0 9.733a3.676 3.676 0 1 1 3.419-3.677 3.514 3.514 0 0 1-.934 2.56 3.506 3.506 0 0 1-2.486 1.117Zm-13.282-9.733a6.072 6.072 0 0 0-4.268 10.373 6.07 6.07 0 0 0 10.353-4.317 5.972 5.972 0 0 0-6.085-6.056Zm0 9.733a3.676 3.676 0 1 1 3.42-3.677 3.505 3.505 0 0 1-3.42 3.677ZM68.03 32.86v2.565h6.156a5.372 5.372 0 0 1-1.425 3.234A6.297 6.297 0 0 1 68 40.541a6.84 6.84 0 1 1 0-13.68 6.612 6.612 0 0 1 4.675 1.838l1.81-1.81a8.975 8.975 0 0 0-6.456-2.593 9.42 9.42 0 1 0 0 18.825 8.648 8.648 0 0 0 6.57-2.637 8.55 8.55 0 0 0 2.223-6.028 8.937 8.937 0 0 0-.129-1.596H68.03Zm64.567 1.995a5.698 5.698 0 0 0-5.187-3.862 5.703 5.703 0 0 0-5.373 3.765 5.705 5.705 0 0 0-.327 2.291 6.03 6.03 0 0 0 8.069 5.728 6.028 6.028 0 0 0 2.989-2.35l-2.066-1.426a3.437 3.437 0 0 1-2.978 1.667 3.065 3.065 0 0 1-2.936-1.838l8.108-3.349-.299-.627Zm-8.265 2.023a3.33 3.33 0 0 1 .844-2.442 3.331 3.331 0 0 1 2.334-1.106 2.336 2.336 0 0 1 2.237 1.296l-5.415 2.252Zm-6.583 5.871h2.664V24.937h-2.664V42.75Zm-4.361-10.403h-.1a4.186 4.186 0 0 0-3.192-1.425 6.072 6.072 0 0 0-4.101 10.251 6.072 6.072 0 0 0 4.101 1.876 4.104 4.104 0 0 0 3.192-1.425h.1v.87c0 2.322-1.24 3.562-3.235 3.562a3.365 3.365 0 0 1-3.063-2.152l-2.309.955a5.702 5.702 0 0 0 5.372 3.591c3.121 0 5.7-1.838 5.7-6.313V31.35h-2.465v.997Zm-3.064 8.38a3.675 3.675 0 0 1-2.45-6.187 3.676 3.676 0 0 1 2.45-1.152 3.407 3.407 0 0 1 3.249 3.662 3.39 3.39 0 0 1-3.249 3.677Zm34.756-15.79h-6.384V42.75h2.665v-6.755h3.719a5.54 5.54 0 0 0 5.48-3.316 5.543 5.543 0 0 0-5.48-7.742Zm0 8.55h-3.719v-6.07h3.776a3.049 3.049 0 1 1 0 6.099l-.057-.029Zm16.445-2.55a4.975 4.975 0 0 0-4.746 2.721l2.352.984a2.534 2.534 0 0 1 2.436-1.297 2.568 2.568 0 0 1 2.554 1.327c.162.3.263.628.296.967v.171a5.954 5.954 0 0 0-2.778-.684c-2.537 0-5.13 1.425-5.13 4.019a4.117 4.117 0 0 0 4.431 3.918 3.779 3.779 0 0 0 3.392-1.738h.085v1.425h2.565v-6.854c0-3.121-2.365-4.93-5.4-4.93l-.057-.03Zm-.328 9.761c-.869 0-2.081-.442-2.081-1.51 0-1.425 1.511-1.91 2.85-1.91a4.733 4.733 0 0 1 2.423.599 3.225 3.225 0 0 1-3.135 2.85l-.057-.029Zm15.133-9.348-3.049 7.724h-.086l-3.163-7.724h-2.85l4.745 10.801-2.707 6h2.778l7.296-16.801h-2.964Zm-23.94 11.4h2.651V24.937h-2.651V42.75Z",
    fill: "#364663"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.877 10.745a2.85 2.85 0 0 0-.67 1.995v31.52a2.765 2.765 0 0 0 .67 1.995l.1.114 17.655-17.655v-.428L14.977 10.645l-.1.1Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.475 34.599-5.843-5.885v-.428l5.843-5.885.128.085 6.997 3.962c1.995 1.126 1.995 2.978 0 4.118l-6.968 3.962-.157.071Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.646 34.514 32.632 28.5 14.878 46.255a2.308 2.308 0 0 0 2.95.1l20.819-11.841",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.646 22.486 17.826 10.66a2.294 2.294 0 0 0-2.949.085L32.632 28.5l6.014-6.014Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.475 34.385 17.827 46.142a2.365 2.365 0 0 1-2.85 0l-.1.1.1.113a2.365 2.365 0 0 0 2.85 0l20.819-11.841-.171-.129Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M14.877 46.056a2.85 2.85 0 0 1-.627-2.01v.215a2.765 2.765 0 0 0 .67 1.994l.1-.1-.143-.099ZM45.6 30.352l-7.125 4.033.128.129 6.997-3.962a2.493 2.493 0 0 0 1.51-2.052 2.65 2.65 0 0 1-1.51 1.852Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M17.827 10.858 45.6 26.648a2.65 2.65 0 0 1 1.51 1.852 2.494 2.494 0 0 0-1.51-2.052L17.827 10.659c-1.98-1.14-3.62-.2-3.62 2.08v.214c.043-2.28 1.64-3.22 3.62-2.095Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 31.065,
    y1: 12.412,
    x2: 7.153,
    y2: 36.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 48.208,
    y1: 28.5,
    x2: 13.737,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 35.383,
    y1: 31.777,
    x2: 2.95,
    y2: 64.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 10.402,
    y1: 0.257,
    x2: 24.881,
    y2: 14.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h192.375v57H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLightBadge);
export default __webpack_public_path__ + "static/media/google-play-light-badge.5409b8d418dcb96199a8e3e3e10b574c.svg";
export { ForwardRef as ReactComponent };